<app-nav>
    <div class="page d-flex flex-column">
        <router-outlet></router-outlet>
        <div class="global-loader">
            <span class="spinner-border spinner-border-lg"></span>
        </div>
    </div>
</app-nav>
